

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { NbCardModule, NbContextMenuModule } from '@nebular/theme';
import { NgxPaginationModule } from 'ngx-pagination';
import { UserCardsComponent } from './user-card.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { FormsModule } from '@angular/forms';


export function playerFactory() {
    return player;
  }

@NgModule({
  imports: [CommonModule,
    NgxPaginationModule,
    NbCardModule,
    NbContextMenuModule,
    LottieModule.forRoot({ player: playerFactory }),
    FormsModule
    

  
  ],
  declarations:[
    UserCardsComponent
  ],
  exports: [UserCardsComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class UserCardModule {}
